import {
  type ID,
  isLibraryRef,
  type LibrarySymbolRef,
} from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

import { PERMISSION_TYPE } from '@/permissions'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'

const hasPermission = (
  state: AppState,
  permission: PROJECT_SETTINGS_PERMISSION
) => state.user.permissions?.[permission]?.type === PERMISSION_TYPE.YES

/** The caller may read the library of the workspace of the project. */
export const selectCanReadLibrary = (state: AppState): boolean =>
  hasPermission(state, PROJECT_SETTINGS_PERMISSION.WORKSPACE_LIBRARY_TAB)

/**
 * The caller may write to the library of the workspace of the project. The
 * matrix knows the role, `canEdit` tells a copywriter from a member.
 */
export const selectCanEditLibrary = (state: AppState): boolean =>
  hasPermission(state, PROJECT_SETTINGS_PERMISSION.WORKSPACE_LIBRARY_EDIT) &&
  state.manager.meta.access.canEdit

export const selectProjectHasLibraryRefs = (state: AppState): boolean =>
  state.manager.project.symbols.some(isLibraryRef)

/** The refs of the project whose library item is gone. */
export const selectMissingLibraryRefs = (state: AppState): LibrarySymbolRef[] =>
  state.manager.project.symbols
    .filter(isLibraryRef)
    .filter((symbol) => !state.library.symbol[symbol.libraryId])

/** The library ids the project refers to. */
export const selectReferencedLibraryIds = (state: AppState): ID[] =>
  state.manager.project.symbols.filter(isLibraryRef).map((s) => s.libraryId)

export const selectOwnLibrarySymbolIds = (state: AppState) =>
  state.library.own.symbol
